import { LenderCreate, LenderEdit, LenderList } from './FinancePartners'

export default {
  list: LenderList,
  create: LenderCreate,
  edit: LenderEdit,
}
